import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { Process } from '../components/Process';
import { Services } from '../components/Services';
import { WhyInkova } from '../components/WhyInkova';
import { Reviews } from '../components/Reviews';
import { Faq } from '../components/Faq';
import { LeadForm } from '../components/LeadForm/LeadForm';
import { FinalCta } from '../components/FinalCta';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { PAGE_DESCRIPTION, PAGE_TITLE } from '../data/site';
function useDocumentMeta() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    document.documentElement.lang = 'es';
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = PAGE_DESCRIPTION;
  }, []);
}
export function LandingFlorida() {
  useDocumentMeta();
  return <div className="min-h-screen w-full bg-cream" data-id="element-348" data-mp="4lrdzsimlsu9">
      <Header data-id="element-349" data-mp="9drcdgj1sdoq" />
      <main data-id="element-350" data-mp="9d95zr2o8j33">
        <Hero data-id="element-351" data-mp="9etyzc9c7tyu" />
        <Problem data-id="element-352" data-mp="9f2bh31jsx9i" />
        <Process data-id="element-353" data-mp="9ekh6byg4t48" />
        <Services data-id="element-354" data-mp="9g54bgifl9s2" />
        <WhyInkova data-id="element-355" data-mp="df4d5c7a9qos" />
        <Reviews data-id="element-356" data-mp="deb5m90i2x5l" />
        <Faq data-id="element-357" data-mp="deuopt1vzrl7" />
        <LeadForm data-id="element-358" data-mp="dekutudq10a8" />
        <FinalCta data-id="element-359" data-mp="dh73jxccllu1" />
      </main>
      <Footer data-id="element-360" data-mp="3cv9gbcvp90jv" />
      <WhatsAppButton data-id="element-361" data-mp="3cvj7h3shddr5" />
    </div>;
}